import { qraftAPIClient as t } from "@openapi-qraft/react";
import * as e from "@openapi-qraft/react/callbacks/index";
import { services as o } from "./services/index.js";
function a(r) {
  return t(o, e, r);
}
export {
  a as createAPIClient
};
